import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import reducers from 'reducers';
import axios from 'axios';
import thunk from 'redux-thunk';
import promiseMiddleware from 'middleware/promise';
import loggerMiddleware from 'middleware/logger';
import analyticsMiddleware from 'middleware/analytics';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable */
const isReduxLogger = process.env.REACT_APP_REDUX_LOGGING
  ? !!process.env.REACT_APP_REDUX_LOGGING
  : false;

axios.interceptors.response.use(
  response => response,
  error => Promise.reject(error),
);

export const storeFactory = () => {
  return createStore(
    reducers,
    composeEnhancers(
      applyMiddleware(
        ...(isReduxLogger ? [logger] : []),
        thunk,
        promiseMiddleware(axios),
        loggerMiddleware,
        analyticsMiddleware,
      ),
    ),
  );
};

const store = storeFactory();

export default store;
